export const LABELS: { [key: string]: string } = {
  generalAppearanceAbnormalStateComments: "General Appearance",
  gastrointestinalAbnormalStateComments: "Gastrointestinal",
  oralCavityAbnormalStateComments: "Oral Cavity",
  musculosceletalAbnormalStateComments: "Musculosceletal",
  mucousMembranesAbnormalStateComments: "Mucous Membranes",
  lymphNodesAbnormalStateComments: "Lymph Nodes",
  eyesAbnormalStateComments: "Eyes",
  urogenitalAbnormalStateComments: "Urogenital",
  earsAbnormalStateComments: "Ears",
  integumentaryAbnormalStateComments: "Integumentary",
  cardiovascularAbnormalStateComments: "Cardiovascular",
  nervousSystemAbnormalStateComments: "Nervous System",
  respiratoryAbnormalStateComments: "Respiratory"
};
